import { Box } from "@drone-js/core";
import { AgodaLogoWithUrl } from "apps/commons/components/AgodaLogo";
import { LanguageSwitcher } from "libs/languageSwitcher";
import type { FunctionComponent } from "react";

export const Header: FunctionComponent = () => {
    return (
        <Box
            as="nav"
            borderWidth={["0", "0", "1"]}
            borderColor="base.default"
            backgroundColor="base.surface"
            borderStyle="solid"
            width="100%"
            zIndex={99}
        >
            <Box display="flex" py="8" px="16" width="100%" justifyContent="space-between" qM={{ px: "32" }}>
                <AgodaLogoWithUrl data-test-id="agoda-logo" />

                <Box display="flex" gap="24">
                    <LanguageSwitcher
                        languageFlagElementName="select-language"
                        languageFlagSelectorElementName="language-selector-link"
                    />
                </Box>
            </Box>
        </Box>
    );
};
